module.exports = __webpack_public_path__ + "img/04.b53e029c.png";